import {Typography} from '@mui/material';
import * as React from 'react';
import {EdgeProps, getSmoothStepPath, EdgeLabelRenderer, BaseEdge} from 'reactflow';

const CustomEdge: React.FC<EdgeProps> = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
}) => {
  const transformX = (x: number, type: string, position: string) => {
    let margin = 0;
    if (type === 'decision') {
      margin = 30;
    } else if (type === 'terminal') {
      margin = 35;
    } else if (type === 'process') {
      margin = 45;
    }

    switch (position) {
      case 'right': {
        return x - margin;
      }
      case 'left': {
        return x + margin;
      }
      default:
        return x;
    }
  };

  const transformY = (y: number, type: string, position: string) => {
    let margin = 0;
    if (type === 'process') {
      margin = 40;
    }
    if (type === 'task') {
      if (position === 'top') {
        margin = 20;
      }
    }

    switch (position) {
      case 'bottom': {
        return y - margin;
      }
      case 'top': {
        return y + margin;
      }
      default:
        return y;
    }
  };

  sourceX = transformX(sourceX, data.parent_node_type, sourcePosition);
  targetX = transformX(targetX, data.child_node_type, targetPosition);
  //sourceX = transformX(sourceX, data.parent_node_type, sourcePosition);
  sourceY = transformY(sourceY, data.parent_node_type, sourcePosition);
  targetY = transformY(targetY, data.child_node_type, targetPosition);
  //sourceY = transformSourceY(sourceY, data.parent_node_type, data.child_node_type, sourcePosition, targetPosition);

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 20,
  });

  const getTransform = () => {
    if (data.label) {
      switch (sourcePosition) {
        case 'top': {
          return `translate(-50%, -50%) translate(${sourceX}px,${sourceY - 20}px)`;
        }
        case 'bottom': {
          return `translate(-50%, -50%) translate(${sourceX}px,${sourceY + 20}px)`;
        }
        case 'right': {
          return `translate(-50%, -50%) translate(${sourceX + 20}px,${sourceY}px)`;
        }
        case 'left': {
          return `translate(-50%, -50%) translate(${sourceX - 20}px,${sourceY}px)`;
        }
      }
    } else return `translate(-50%, -50%) translate(${sourceX}px,${sourceY}px)`;
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={{stroke: '#A1A4AC', strokeWidth: '2px'}} />
      {data.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: getTransform(),
              background: data.label === 'y' ? '#58AD2F' : '#E1242A',
              borderRadius: 15,
              width: '29px',
              height: '31px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className='nodrag nopan'
          >
            <Typography fontSize={12} variant='h4' color='white'>
              {data.label === 'y' ? 'Yes' : 'No'}
            </Typography>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default CustomEdge;
